var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "main-visual-requirement",
    attrs: {
      "tile": "",
      "flat": "",
      "height": "100%",
      "color": "#171C21"
    }
  }, [_c('div', {
    staticClass: "white--text w-100"
  }, [_c('tit-wrap', {
    staticClass: "tit-wrap--sm"
  }, [_c('tit', {
    staticClass: "font-size-lg-32 line-height-14"
  }, [_vm._v(" 간단하게 확인하는 "), _c('br'), _vm._v(" 서울 건대입구역 청약자격! ")])], 1), _c('v-row', {
    staticClass: "row--xxs"
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-col', {
      key: item,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      staticClass: "pa-12px pa-md-16px",
      attrs: {
        "tile": "",
        "flat": "",
        "color": "rgba(255,255,255,0.05)"
      }
    }, [_c('txt', {
      staticClass: "txt--lg white--text"
    }, [_c('v-row', {
      staticClass: "row--xxs"
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("0" + _vm._s(index + 1) + ".")])]), _c('v-col', [_c('span', {
      staticClass: "grey--text text--lighten-1"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])])], 1)], 1)], 1)], 1)];
  })], 2), _c('tit', {
    staticClass: "tit--sm pt-30px pt-md-48px line-height-14"
  }, [_vm._v(" 일반공급 소득 · 재산 · 지역 조건 없이 "), _c('br'), _vm._v(" 지원 가능 ")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }